<script lang="ts">
	import ContentCalendar from '@icons/ContentCalendar.svelte';
	import Input from '../Input.svelte';
	import type { PickerDateRange } from './types';
	import DateRangePicker from './DateRangePicker.svelte';
	import { format } from 'date-fns';
	import { onDestroy, onMount } from 'svelte';
	import { browser } from '$app/environment';
	import ClickOutside from '@components/ClickOutside.svelte';

	let className = '';
	export { className as class };
	export let selectedRange: PickerDateRange = {
		start: undefined,
		end: undefined
	};
	export let label: string = 'Zeitraum';

	let showDatePicker = false;

	let inputValue = '';

	function generateInputValue(start: Date | undefined, end: Date | undefined) {
		if (start && !end) {
			return format(start, 'dd.MM.');
		}
		if (start && end) {
			return `${format(start, 'dd.MM.')} - ${format(end, 'dd.MM.')}`;
		}
		return '';
	}

	$: inputValue = generateInputValue(selectedRange.start, selectedRange.end);

	function handleKeydown(e: KeyboardEvent) {
		if (e.key === 'Escape') {
			showDatePicker = false;
		}
	}

	function toggleDatePicker() {
		showDatePicker = !showDatePicker;
	}

	onMount(() => {
		if (browser) {
			window.addEventListener('keydown', handleKeydown);
		}
	});

	onDestroy(() => {
		if (browser) {
			window.removeEventListener('keydown', handleKeydown);
		}
	});
</script>

<ClickOutside
	on:click={() => {
		showDatePicker = false;
	}}
	class="flex-grow {className}"
>
	<Input
		value={inputValue}
		{label}
		id="event-date-range-input"
		on:click={toggleDatePicker}
		on:enter={toggleDatePicker}
		button={{
			icon: ContentCalendar,
			ariaLabel: 'Kalender öffnen',
			onClick: toggleDatePicker,
			ariaHasPopup: 'dialog',
			ariaExpanded: showDatePicker,
			ariaControls: 'date-picker-popup'
		}}
	/>

	{#if showDatePicker}
		<div role="dialog" id="date-picker-popup" aria-modal="true">
			<DateRangePicker bind:selectedRange on:select />
		</div>
	{/if}
</ClickOutside>
